export default __webpack_public_path__ + "static/media/iconAddPhoto.cd28c030.svg";